import { Icon } from "@trustpilot/businessapp-patternlibrary";
import { arrowRight_16 as arrowRight } from "@trustpilot/icons";
import { Text } from "ilenia";
import React, { useContext } from "react";

import { SecondaryNavWithSubNav, SecondaryNavWithOutSubNav } from ".";
import { trackingConst } from "../../../../constants";
import { useAnalytics } from "../../../../utils/analytics";
import { NavContext } from "../../index";
import styles from "../../styles/sideNav.module.scss";
import * as Types from "../../types";
import { keyboardEnterOrSpaceClick } from "../../utils/accessiblity";
import { useIsSmall, useIsMaxMedium } from "../../utils/useMedia";
import { Badge } from "../primaryNav/primaryNavBadge";

interface SecondaryNavSubProps {
  menu: Types.SubItem;
  setIsMainMenuCollapsed: (value: boolean) => void;
}
const SecondaryNavSub: React.FC<SecondaryNavSubProps> = ({
  menu,
  setIsMainMenuCollapsed,
}: {
  menu: Types.SubItem;
  setIsMainMenuCollapsed: (toggleCollapsedMenu: boolean) => void;
}) => {
  const [toggleSecondary, setToggleSecondary] = React.useState(true);
  const navigationVal = useContext(NavContext);
  const { openSubMenu, navItems, setNavItems, setShowSubMenu } = navigationVal;
  const isSmall = useIsSmall();
  const isIntermediate = useIsMaxMedium();
  const analytics = useAnalytics();

  const openSecondarySubMenu = React.useCallback(
    (menu, evt) => {
      evt.preventDefault();

      setNavItems({
        ...navItems,
        isOpenSecondarySubmenu: menu.id,
      });

      openSubMenu(menu, evt);
    },
    [navItems, setNavItems],
  );

  const openTertiarySubMenu = (menu: Types.SubItem, evt: Types.Event) => {
    evt.preventDefault();

    setNavItems({
      ...navItems,
      isOpenSecondarySubmenu: null,
      isTertiarySubmenu: menu.id,
    });

    setIsMainMenuCollapsed(true);
    openSubMenu(menu, evt);
  };

  return (
    <>
      <li
        key={menu.id}
        data-testid={menu.id}
        className={`${
          menu.subMenu
            ? toggleSecondary
              ? `${styles.active}`
              : ""
            : navItems?.isOpenSecondarySubmenu === menu.id
            ? `${styles.active}`
            : ""
        } ${menu.subMenu ? `${styles.activeSec}` : ""} `}
      >
        {!menu.subMenu ? (
          <SecondaryNavWithOutSubNav
            menu={menu}
            isSmall={isSmall}
            isIntermediate={isIntermediate}
            toggleSecondary={toggleSecondary}
            setToggleSecondary={setToggleSecondary}
            openSecondarySubMenu={openSecondarySubMenu}
            setIsMainMenuCollapsed={setIsMainMenuCollapsed}
            setShowSubMenu={setShowSubMenu}
          />
        ) : (
          <>
            <SecondaryNavWithSubNav
              menu={menu}
              isSmall={isSmall}
              isIntermediate={isIntermediate}
              toggleSecondary={toggleSecondary}
              setToggleSecondary={setToggleSecondary}
              openSecondarySubMenu={openSecondarySubMenu}
              setIsMainMenuCollapsed={setIsMainMenuCollapsed}
              setShowSubMenu={setShowSubMenu}
            />
            <ul>
              {menu?.subMenu &&
                Array.isArray(menu.subMenu) &&
                menu.subMenu.map((menu: Types.SubItem) => {
                  return (
                    <li
                      key={menu.id}
                      className={`${navItems?.isTertiarySubmenu === menu.id ? `${styles.active}` : ""}`}
                      data-testid={menu.id}
                    >
                      <a
                        onClick={(event) => {
                          openTertiarySubMenu(menu, event);
                          if (isSmall && isIntermediate) {
                            setIsMainMenuCollapsed(true);
                            setShowSubMenu(false);
                          }
                          analytics.track(trackingConst.events.navigationClicked, {
                            state: menu.href,
                            context: trackingConst.contexts.appshell,
                          });
                        }}
                        onKeyDown={(event) => {
                          keyboardEnterOrSpaceClick(event, () => {
                            openTertiarySubMenu(menu, event);
                            if (isSmall && isIntermediate) {
                              setIsMainMenuCollapsed(true);
                              setShowSubMenu(false);
                            }
                            analytics.track(trackingConst.events.navigationClicked, {
                              state: menu.href,
                              context: trackingConst.contexts.appshell,
                            });
                          });
                        }}
                        href={menu.href ? menu.href : null}
                        tabIndex={0}
                      >
                        <span className={styles.sidebarLinksText}>
                          <Text id={`Sidebar.${menu.id}`} /> {menu.data && `(${menu.data})`}
                        </span>
                        {menu.hasNewBadge && <Badge />}
                        <span className={styles.sidebarLinksIconArrow}>
                          <Icon content={arrowRight} />
                        </span>
                      </a>
                    </li>
                  );
                })}
            </ul>
          </>
        )}
      </li>
    </>
  );
};

export default SecondaryNavSub;
